function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import utils from '../../../common/utils/index.js';
import LoveButton from '../loveButton/loveButton.js';
import { GalleryComponent } from '../../galleryComponent';
import window from '../../../common/window/windowWrapper';
import { isSiteMode, isSEOMode } from '../../../common/window/viewModeWrapper';
import EVENTS from '../../../common/constants/events';
import PLACEMENTS from '../../../common/constants/placements';
import { URL_TYPES, URL_SIZES } from '../../../common/constants/urlTypes';
import DownloadIcon from '../../svgs/components/download';
import ShareStoreIcon from '../../svgs/components/share_store';

var Social = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(Social, _GalleryComponent);

  var _super = _createSuper(Social);

  function Social(props) {
    var _this;

    _this = _GalleryComponent.call(this, props) || this;
    _this.onDownloadKeyPress = _this.onDownloadKeyPress.bind(_assertThisInitialized(_this));
    _this.onDownloadTextKeyPress = _this.onDownloadTextKeyPress.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Social.prototype;

  _proto.getSocialShare = function getSocialShare() {
    var _this$props = this.props,
        styleParams = _this$props.styleParams,
        id = _this$props.id,
        actions = _this$props.actions;

    if (styleParams.allowSocial) {
      var slideshowShareButton = /*#__PURE__*/React.createElement("i", {
        className: 'block-fullscreen share-store'
      }, /*#__PURE__*/React.createElement(ShareStoreIcon, {
        size: "20"
      }));

      if (isSiteMode() || isSEOMode()) {
        var slideshowShare = styleParams.isSlideshow ? actions.getShare() : '';
        return /*#__PURE__*/React.createElement("div", {
          className: 'block-fullscreen gallery-item-social-share gallery-item-social-button',
          "data-hook": "gallery-item-social-button",
          key: 'item-social-share-' + id,
          onClick: function onClick(e) {
            return actions.toggleShare(e, true);
          }
        }, slideshowShareButton, slideshowShare);
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: 'show-tooltip block-fullscreen gallery-item-social-share gallery-item-social-button',
          "data-hook": "gallery-item-social-button",
          key: 'item-social-share-' + id,
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        }, slideshowShareButton);
      }
    }

    return '';
  };

  _proto.getLoveButton = function getLoveButton() {
    var _this$props2 = this.props,
        styleParams = _this$props2.styleParams,
        isNarrow = _this$props2.isNarrow,
        isSmallItem = _this$props2.isSmallItem;
    var props = utils.pick(this.props, ['id', 'item', 'idx', 'currentIdx', 'styleParams', 'hashtag', 'type', 'actions', 'loveCount', 'isLoved']);
    return styleParams.loveButton ? /*#__PURE__*/React.createElement(LoveButton, _extends({}, props, {
      itemId: this.props.photoId,
      layout: styleParams.isSlideshow ? 'slideshow' : 'gallery',
      showCounter: styleParams.loveCounter && !isSmallItem && !isNarrow
    })) : '';
  };

  _proto.getDownload = function getDownload() {
    var _this2 = this;

    var _this$props3 = this.props,
        styleParams = _this$props3.styleParams,
        isDemo = _this$props3.isDemo,
        type = _this$props3.type,
        createUrl = _this$props3.createUrl,
        actions = _this$props3.actions;

    if (styleParams.allowDownload && !((isSiteMode() || isSEOMode()) && isDemo)) {
      var className = 'block-fullscreen gallery-item-social-download ' + (styleParams.allowSocial ? '' : ' pull-right ') + ' gallery-item-social-button';
      var downloadIcon = /*#__PURE__*/React.createElement("i", {
        className: 'block-fullscreen ' + (isDemo ? ' inactive' : '')
      }, /*#__PURE__*/React.createElement(DownloadIcon, {
        size: "20"
      }));
      var genralProps = {
        className: className,
        'data-hook': 'item-download',
        'aria-label': 'Download',
        role: 'button',
        tabIndex: styleParams.isSlideshow && this.props.currentIdx === this.props.idx ? 0 : -1
      };
      var downloadUrl = styleParams.isStoreGallery ? URL_SIZES.DOWNLOAD_SAMPLE : URL_SIZES.DOWNLOAD;
      var downloadLink = createUrl(downloadUrl, URL_TYPES.VIDEO) || createUrl(downloadUrl, URL_TYPES.HIGH_RES);
      var itemProps = {
        target: '_blank',
        href: downloadLink,
        onClick: function onClick(e) {
          e.stopPropagation();
          e.preventDefault();
          window.open(downloadLink, '_blank');

          _this2.props.actions.eventsListener(EVENTS.DOWNLOAD_BUTTON_CLICKED, _this2.props);
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.onDownloadKeyPress(e, downloadLink);
        }
      };

      if (type === 'text') {
        return /*#__PURE__*/React.createElement("div", _extends({}, genralProps, {
          onClick: function onClick(e) {
            e.stopPropagation();
            actions.eventsListener(EVENTS.TEXT_DOWNLOAD_BUTTON_CLICKED, _this2.props);
          },
          onKeyDown: function onKeyDown(e) {
            return _this2.onDownloadTextKeyPress(e);
          }
        }), downloadIcon);
      } else {
        if (!isDemo) {
          return /*#__PURE__*/React.createElement("div", _extends({}, genralProps, {
            download: "download"
          }, itemProps), downloadIcon);
        } else {
          return /*#__PURE__*/React.createElement("div", _extends({}, genralProps, {
            download: "download"
          }), downloadIcon);
        }
      }
    }

    return '';
  };

  _proto.onDownloadKeyPress = function onDownloadKeyPress(e, downloadLink) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.stopPropagation();
        e.preventDefault();
        window.open(downloadLink, '_blank');
        this.props.actions.eventsListener(EVENTS.DOWNLOAD_BUTTON_CLICKED, this.props);
        return false;
    }
  };

  _proto.onDownloadTextKeyPress = function onDownloadTextKeyPress(e) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.stopPropagation();
        this.props.actions.eventsListener(EVENTS.TEXT_DOWNLOAD_BUTTON_CLICKED, this.props);
        return false;
    }
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        styleParams = _this$props4.styleParams,
        id = _this$props4.id,
        showShare = _this$props4.showShare,
        isSmallItem = _this$props4.isSmallItem,
        isNarrow = _this$props4.isNarrow,
        isShort = _this$props4.isShort,
        isVerticalContainer = _this$props4.isVerticalContainer;
    var socialShare = this.getSocialShare();
    var loveButton = this.getLoveButton();
    var download = this.getDownload(); //var shopIcons = this.getShopIcons();

    var isShowArrows = styleParams.hasThumbnails;
    var isPopulated = styleParams.allowSocial || styleParams.loveButton || styleParams.allowDownload;
    var textPlacementAboveOrBelowOrRightOrLeft = styleParams.titlePlacement === PLACEMENTS.SHOW_BELOW || styleParams.titlePlacement === PLACEMENTS.SHOW_ABOVE || styleParams.titlePlacement === PLACEMENTS.SHOW_ON_THE_RIGHT || styleParams.titlePlacement === PLACEMENTS.SHOW_ON_THE_LEFT;
    var classes = [[showShare, 'hidden'], [isSmallItem, 'small-item'], [isShort, 'short-item'], [isNarrow, 'narrow-item'], [isVerticalContainer, 'vertical-item'], [isShowArrows, 'with-arrows'], [isPopulated, 'populated-item'], [textPlacementAboveOrBelowOrRightOrLeft, 'text-external-item']].filter(function (x) {
      return x[0];
    }).map(function (x) {
      return x[1];
    }).join(' ');
    return /*#__PURE__*/React.createElement("div", {
      className: 'gallery-item-social gallery-item-direction-' + styleParams.galleryTextAlign + ' ' + classes,
      key: 'item-social-' + id,
      "data-hook": "item-social"
    }, loveButton, download, socialShare);
  };

  return Social;
}(GalleryComponent);

export { Social as default };